module.exports = new __parcel__URL__("marvel-logo.2c5d447c.jpeg").toString();